<!--  -->
<template>
  <div class="tabseboxr">
    <div class="selcet_box search_box">
      <el-input v-model="parameter.queue" style="width:200px;" placeholder="请输入内容" />
      <el-date-picker
        v-model="timearr"
        format="yyyy-MM-dd HH:mm:ss"
        value-format="yyyy-MM-dd HH:mm:ss"
        :default-time="['00:00:00', '23:59:59']"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="datavalue"
      />
      <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
      <el-button icon="el-icon-refresh-right" type="info" @click="reast">重置</el-button>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="id"
        label="id"
        width="100"
        align="center"
      />
      <el-table-column
        prop="connection"
        label="连接驱动"
        width="100"
        align="center"
      />
      <el-table-column
        prop="exception"
        label="异常信息"
        width="590"
        align="center"
      />
      <el-table-column
        prop="queue"
        label="队列名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="failed_at"
        label="失败时间"
        width="180"
        align="center"
      />
      <el-table-column
        prop="uuid"
        label="uuid"
        width="300"
        align="center"
      />
      <el-table-column
        prop="qrcode_img"
        label="操作"
        width="200"
        align="center"
      >
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="error(scope.row.id,'exception')">异常信息</el-button>
          <el-button size="mini" type="danger" @click="error(scope.row.id,'payload')">载荷</el-button>
        </template>
      </el-table-column>
    </el-table>
    <PaginationRight
      :current-page="parameter.page"
      :total="total"
      @size-change="fetchPageSizeone"
      @current-change="fetchCurrentPageone"
    />
    <el-dialog
      title="错误信息"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <div class="detail_box">{{ detail }}</div>
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight'
import { errorListre, errorDetail } from '@/api/enterpriseWeChatCustomerService'
export default {
  name: 'Errorqueue',
  components: { PaginationRight },
  data() {
    return {
      total: null,
      tableData: [],
      dialogVisible: false,
      detail: '',
      timearr: [],
      parameter: {
        page: 1,
        page_size: 10,
        queue: null,
        start: null,
        end: null
      }
    }
  },
  created() {
    this.getList()
  },
  mounted() {

  },
  methods: {
    datavalue(val) {
      this.parameter.start = val[0]
      this.parameter.end = val[1]
    },
    async getList() {
      const data = await errorListre(this.parameter)
      this.tableData = data.data.list
      this.total = data.data.total
    },
    fetchPageSizeone(e) {
      this.parameter.page_size = e
      this.getList()
    },

    fetchCurrentPageone(e) {
      this.parameter.page = e
      this.getList()
    },
    search() {
      this.parameter.page = 1
      this.getList()
    },
    reast() {
      this.parameter = {
        page: 1,
        page_size: 10,
        queue: null,
        start: null,
        end: null
      }
      this.getList()
    },
    async error(id, type) {
      const data = await errorDetail({
        id: id,
        column: type
      })
      this.dialogVisible = true
      if (data.data.detail) {
        this.detail = data.data.detail
      } else {
        this.detail = data.data.payload
      }

      console.log('data', data)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tabseboxr{
  padding: 20px;
}
.detail_box{
  max-height: 600px;
  overflow-x: scroll;
  line-height: 20px;
}
.selcet_box{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
</style>
